<template>
  <div>
    <nav
      class="top-0 h-[90px] bg-white fixed z-50 w-full flex flex-wrap navbar-expand-lg items-center"
    >
      <div
        class="container flex justify-between max-w-full sm:max-w-[1200px] mx-auto h-12 items-center px-5"
      >
        <div class="bg-white self-start shrink-0 px-2">
          <router-link
            to="/"
            class="text-white text-sm font-bold leading-relaxed inline-block whitespace-nowrap uppercase"
          >
            <img
              src="/img/csvrag-logo.png"
              class="w-[50px] h-[50px]"
              alt="CSVRAG - Enable RAG on your CSV"
            />
          </router-link>
        </div>
        <div class="block sm:hidden">
          <button aria-label="Mobile Navigation Menu" @click="toggleMenu()">
            <div class="hamburger">
              <div class="hamburger-line"></div>
              <div class="hamburger-line"></div>
              <div class="hamburger-line"></div>
            </div>
          </button>
        </div>
        <div class="hidden sm:block">
          <div class="flex items-center pl-10">
            <div @click="scrollToElement('how-it-works')" class="flex items-center mr-2 pr-2 md:pr-5 cursor-pointer uppercase">
              <span class="text-sm">How&nbsp;It&nbsp;Works</span>
            </div>
            <div @click="scrollToElement('pricing')" class="flex items-center mr-2 pr-2 md:pr-5 cursor-pointer uppercase">
              <span class="text-sm">Pricing</span>
            </div>
            <!-- <div class="md:border-r border-blueGray-400 mx-2 md:mx-5">
              &nbsp;
            </div>
            <template v-if="$store.getters.isCheckingAuth">
              <i class="fas fa-circle-notch fa-spin mr-3 text-blueGray-300"></i>
            </template>
            <template v-else-if="!$store.getters.isPersonLoggedIn">
              <a :href="`${webBaseUrl}`">
                <div
                  class="flex items-center mx-2 px-5 py-3 rounded-lg cursor-pointer uppercase"
                >
                  <h6 class="text-sm font-bold">Login</h6>
                </div>
              </a>
              <a :href="`${webBaseUrl}/auth/register`">
                <div
                  class="flex items-center mx-2 pr-2 py-3 rounded-r-lg mr-2 cursor-pointer uppercase"
                >
                  <h6 class="text-sm font-bold">Sign&nbsp;Up</h6>
                </div>
              </a>
            </template>
            <template v-else>
              <div class="mb-3 mt-2 pt-2 hidden md:block">
                <div class="mx-auto max-w-[200px]">
                  <div class="flex items-center">
                    <div class="ml-3 overflow-x-hidden">
                      <p class="block text-sm">
                        Hello, {{ $store.getters.person.firstName }}
                      </p>
                      <p
                        class="text-xs text-blueGray-400 max-w-full overflow-x-hidden text-ellipsis"
                      >
                        {{ $store.getters.person.calc_EmailAddress }}
                      </p>
                      <p
                        v-if="$store.getters.isImpersonating"
                        class="text-xs text-black hidden sm:block whitespace-nowrap bg-orange-200 px-1 py-0 mb-2 overflow-x-hidden text-ellipsis"
                      >
                        <em
                          >Impersonated by
                          {{ $store.getters.isImpersonating }}</em
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </template> -->
          </div>
        </div>
      </div>
    </nav>
    <div
      :class="{ 'not-shown': !menuOpen }"
      class="nav-menu fixed w-[100vh] h-[100vh] top-0 bg-white"
    >
      <div class="absolute left-[calc(100vw_-_90px)]">
        <a href="#" aria-label="Toggle Menu" @click="toggleMenu()">
          <div class="hamburger">
            <div class="hamburger-x hamburger-x-left"></div>
            <div class="hamburger-x hamburger-x-right"></div>
          </div>
        </a>
      </div>
      <div class="flex flex-col mt-[100px]">
        <div class="flex items-center cursor-pointer mb-5 px-10" @click="scrollToElement('home'); toggleMenu()">
          <span class="text-2xl">Home</span>
        </div>
        <div class="flex items-center cursor-pointer mb-5 px-10" @click="scrollToElement('how-it-works'); toggleMenu()">
          <span class="text-2xl">How It Works</span>
        </div>
        <div class="flex items-center cursor-pointer mb-5 px-10" @click="scrollToElement('pricing'); toggleMenu()">
          <span class="text-2xl">Pricing</span>
        </div>
        <!-- <template v-if="!$store.getters.isPersonLoggedIn">
          <hr class="mb-4" />
          <a :href="`${webBaseUrl}`" @click="toggleMenu()">
            <div class="flex items-center cursor-pointer mb-5 px-10">
              <h6 class="text-2xl rounded-lg">
                Login
              </h6>
            </div>
          </a>
          <a :href="`${webBaseUrl}/auth/register`" @click="toggleMenu()">
            <div class="flex items-center cursor-pointer mb-5 px-10">
              <h6 class="text-2xl rounded-lg">Sign&nbsp;Up</h6>
            </div>
          </a>
        </template>
        <template v-if="$store.getters.isPersonLoggedIn">
          <div
            class="w-full mb-3 mt-2 block md:hidden bg-blueGray-100 py-3 px-10"
          >
            <p
              v-if="$store.getters.isImpersonating"
              class="text-2xl text-black hidden sm:inline-block bg-orange-200 px-1 py-0 mb-2"
            >
              <em>Impersonated by {{ $store.getters.isImpersonating }}</em>
            </p>
            <div class="flex items-center">
              <div class="overflow-x-hidden">
                <p class="block text-2xl">
                  Hello, {{ $store.getters.person.firstName }}
                </p>
                <p
                  class="text-blueGray-400 max-w-full overflow-x-hidden text-ellipsis"
                >
                  {{ $store.getters.person.calc_EmailAddress }}
                </p>
              </div>
            </div>
          </div>
        </template> -->
      </div>
    </div>
  </div>
</template>

<script>
import { utils } from "common-frontend";

const { keysToSnake } = utils;

export default {
  components: {},
  data() {
    return {
      webBaseUrl: import.meta.env.VITE_WEB_BASE_URL,
      adminBaseUrl: import.meta.env.VITE_ADMIN_BASE_URL,
      menuOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    toggleResourcesMenu() {
      this.resourcesMenuOpen = !this.resourcesMenuOpen;
    },
    scrollToElement(elementId) {
      const el = document.getElementById(elementId);
      console.log(el);
      if (el) {
        const offsetTop = el.offsetTop;
        console.log(offsetTop);
        window.scrollTo({
          top: offsetTop,
          left: 0,
          behavior: "smooth",
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.hamburger {
  margin: 25px;
  width: 40px;
  top: 5px;
  position: relative;

  .hamburger-line {
    width: 40px;
    height: 5px;
    background-color: #cccccc;
    border-radius: 2px;
    margin-bottom: 8px;
  }

  .hamburger-x {
    width: 40px;
    height: 5px;
    background-color: #bbbbbb;
    border-radius: 2px;
    position: relative;

    &.hamburger-x-left {
      transform: rotate(45deg);
    }
    &.hamburger-x-right {
      transform: rotate(-45deg);
      top: -4px;
    }
  }
}
.nav-menu {
  transition: 0.5s ease-in-out;
  opacity: 1;
  left: 0vh;
  pointer-events: all;
  z-index: 50;

  &.not-shown {
    opacity: 0;
    left: 100vh;
    pointer-events: none;
  }
}
</style>
